import ApiService from '@/data/services/ApiService'
import { ICreateProtocol, IProtocol } from '@/data/models/Protocol'
import { IPaginationQueryParams } from '@/data/models/Pagination'
import { AxiosResponse } from 'axios'
import { IPaginatedServiceResponse, IServiceResponse } from '@/data/models/ServiceResponse'

export interface IProtocolGetPaginatedQuery extends IPaginationQueryParams {
  teamId?: number;
}

export class DiagnosticProtocolApiService extends ApiService {
  /**
   * Returns paginated list of Protocols
   *
   * @param query
   */
  static async getPaginated(query: IProtocolGetPaginatedQuery): Promise<IPaginatedServiceResponse<IProtocol>> {
    return this.axios.get('diagnostic-protocols', { params: query })
      .then((response: AxiosResponse<IPaginatedServiceResponse<IProtocol>>) => response.data)
  }

  static async getAll(query: IProtocolGetPaginatedQuery): Promise<IServiceResponse<IProtocol>> {
    return this.axios.get('diagnostic-protocols', { params: query })
      .then((response: AxiosResponse<IServiceResponse<IProtocol>>) => response.data)
  }

  /**
   * Given protocol's id, fetches protocol data from database
   *
   * @param id
   */
  static async getProtocolDetails(id: string): Promise<IServiceResponse<IProtocol>> {
    return this.axios.get(`diagnostic-protocols/${id}`)
      .then((response: AxiosResponse) => response.data)
  }

  /**
   * Given data, creates new entry in database
   *
   * @param protocolFormData
   */
  static async create(protocolFormData: ICreateProtocol): Promise<IServiceResponse<IProtocol>> {
    return this.axios.post('diagnostic-protocols', protocolFormData)
      .then((response: AxiosResponse<IServiceResponse<IProtocol>>) => response.data)
  }

  /**
   * Given data, updates protocol's entry in database
   *
   * @param data
   */
  static async update(data: IProtocol): Promise<IServiceResponse<IProtocol>> {
    return this.axios.put(`diagnostic-protocols/${data.id}`, data)
      .then((response: AxiosResponse<IServiceResponse<IProtocol>>) => response.data)
  }

  /**
   * Given protocol's id, deletes event in database
   *
   * @param diagnosticProtocolId
   */
  static async delete(diagnosticProtocolId: string): Promise<AxiosResponse> {
    return this.axios.delete(`diagnostic-protocols/${diagnosticProtocolId}`)
  }
}
